import { makeStyles } from "@material-ui/core";
export var useStyles = makeStyles(function () { return ({
    time: {
        color: "black",
    },
    timeStyleUtc: {
        paddingLeft: "8px",
        display: "flex",
        alignItems: "center",
    },
    timeStyleLocal: {
        paddingRight: "8px",
        display: "flex",
        alignItems: "center",
    },
    titleTime: {
        color: "#595D6B",
        fontSize: 14,
        fontWeight: 400,
        paddingLeft: "5px",
    },
    divider: {
        height: 18,
        margin: 0,
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: "solid",
        borderColor: "#E0E0E0",
        borderBottomWidth: 0,
        borderRightWidth: "thin",
    },
}); });
